export const compareExtensions = (
  currentExt: string,
  newExt: string
): boolean => {
  const extension1 = currentExt.split(".").pop()?.toLowerCase();
  const extension2 = newExt.split(".").pop()?.toLowerCase();

  return extension1 !== extension2;
};
export const isInvalidFileExtension = (filename: string) => {
  const parts = filename.split(".");
  const extension = parts[parts.length - 1].toLowerCase();

  const allowedExtensions = [
    "jpg",
    "jpeg",
    "png",
    "pdf",
    "txt",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "odt",
    "ods",
  ];

  return !allowedExtensions.includes(extension);
};
